import React from "react";
import { domainDescriptionStatus } from "../../utils/domainDescription";

// Live character count under a listing description editor, flagging when the
// copy is longer than domain.com.au accepts. Informational only: nothing is
// blocked, Domain just receives a trimmed version (see utils/domainDescription).
export default function DomainDescriptionCounter({ text }) {
  const { length, over, shown, limit } = domainDescriptionStatus(text);
  const fmt = (n) => n.toLocaleString();
  return (
    <div
      className={`mt-2 text-[11px] font-medium ${over ? "text-amber-700" : "text-[#374151] opacity-60"}`}
      data-testid="domain-description-counter"
    >
      {over ? (
        <>
          {fmt(length)} characters. Over domain.com.au&apos;s {fmt(limit)} limit by {fmt(length - limit)}:
          Domain will show the first {fmt(shown)} (cut at the last paragraph break). Shorten it here to control
          what Domain displays. REA and the website show the full text.
        </>
      ) : (
        <>
          {fmt(length)} / {fmt(limit)} characters (domain.com.au limit)
        </>
      )}
    </div>
  );
}
